module.exports = __webpack_public_path__ + "site/img/51.372b4af2.jpg";